var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-settings content-box"},[_c('section',{staticClass:"lang-settings"},[_c('lang-menu',{attrs:{"value":_vm.lang},on:{"change":_vm.setLanguage}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }